import {
  BlindMapQuestionValidator,
  HotspotValidator,
  MenuItemValidator,
  NonSequencedFlowValidator,
  QuizValidator,
  SectionValidator,
  SequenceFlowValidator,
} from './validators';
import { ResourcesFolderValidator } from './validators/ResourcesFolderValidator';
import { ValidationStatus } from './validators/types';
import {
  BlindMapQuestion,
  Hotspot,
  Item,
  ItemType,
  MenuItem,
  NonSequencedFlowItem,
  Quiz,
  ResourcesFolder,
  Section,
  SequencedFlowItem,
} from '@ael/core-api';
import { List } from 'immutable';

export class ItemValidator {
  public static isValid(item: Item, items?: List<Item>): boolean {
    switch (item.type) {
      // Main item types
      case ItemType.MenuItem:
        return MenuItemValidator.isValid(item as MenuItem, items);
      case ItemType.SequencedFlow:
        return SequenceFlowValidator.isValid(item as SequencedFlowItem);
      case ItemType.NonSequencedFlow:
        return NonSequencedFlowValidator.isValid(item as NonSequencedFlowItem);
      case ItemType.Quiz:
        return QuizValidator.isValid(item as Quiz, items);
      case ItemType.ResourcesFolder:
        return ResourcesFolderValidator.isValid(item as ResourcesFolder);

      // Content item types
      case ItemType.Section:
        return SectionValidator.isValid(item as Section);
      case ItemType.Hotspot:
        return HotspotValidator.isValid(item as Hotspot);
      case ItemType.BlindMapQuestion:
        return BlindMapQuestionValidator.isValid(item as BlindMapQuestion);
      default:
        return true;
    }
  }
  public static validate(item: Item, items?: List<Item>): ValidationStatus[] {
    switch (item.type) {
      // Main item types
      case ItemType.MenuItem:
        return MenuItemValidator.validate(item as MenuItem, items);
      case ItemType.SequencedFlow:
        return SequenceFlowValidator.validate(item as SequencedFlowItem);
      case ItemType.NonSequencedFlow:
        return NonSequencedFlowValidator.validate(item as NonSequencedFlowItem);
      case ItemType.Quiz:
        return QuizValidator.validate(item as Quiz, items);
      case ItemType.ResourcesFolder:
        return ResourcesFolderValidator.validate(item as ResourcesFolder);

      // Content item types
      case ItemType.Section:
        return SectionValidator.validate(item as Section);
      case ItemType.Hotspot:
        return HotspotValidator.validate(item as Hotspot);
      case ItemType.BlindMapQuestion:
        return BlindMapQuestionValidator.validate(item as BlindMapQuestion);
      default:
        return [];
    }
  }
}
